export default __webpack_public_path__ + "static/IDMC_GRID_2022 Desplazamiento interno por conflicto y desastres en 2021-b27f3d50e3628c2aae566e44bc6db11e.jpg";